import { createElement } from 'react';
import PropTypes from 'prop-types';

import { createComponentFactory } from 'fela';

export default createComponentFactory(createElement, {
  renderer: PropTypes.object,
  theme: PropTypes.object
}, true);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fela/es/createComponentWithProxy.js
// module id = 791
// module chunks = 0